// components/Settings/Logout.js
import { useEffect } from 'react';
import axios from 'axios';

function Logout() {
    useEffect(() => {
        const doLogout = async () => {
            try {
                await axios.post('/api/login/logout', {}, { withCredentials: true });
            } catch (error) {
                console.error('Logout failed:', error);
            }
            
            localStorage.removeItem('userRole');
            localStorage.removeItem('firstName');
            localStorage.removeItem('userId');
            localStorage.removeItem('clientId');
            sessionStorage.clear();
            window.location.href = '/login';
        };

        doLogout();
    }, []);

    return null; // No UI needed
}

export default Logout;
